export const isLastInstallmentChecked = (data, selected) => {
    let checked = false
    selected.map(e => {
        if (e.installmentId === data[data.length - 1].installmentId) {
            console.log(e)
            if (e.isChecked) {
                checked = true
            }
        }
    })

    return checked
}